// NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1 className="card-title">You are ahead of your time</h1>
      <p className="card-text">This feature is currently being built. Check back again later! </p>
      <Link to="/">Go back to Home</Link>
    </div>
  );
};

export default NotFound;
